module.exports = __webpack_public_path__ + "img/reflect-stream.4521b22.jpg";